import { render, staticRenderFns } from "./AccessHistory.vue?vue&type=template&id=28222d9c"
import script from "./AccessHistory.vue?vue&type=script&lang=js"
export * from "./AccessHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports